import firebase from "firebase/app";
import "firebase/database";
import "firebase/analytics";

require("firebase/auth");
var firebaseConfig;
const nodeEnv =
  window.configs && window.configs.NODE_ENV !== ""
    ? window.configs.NODE_ENV
    : process.env.NODE_ENV;
try {
  try {
    firebaseConfig =
      nodeEnv === "production"
        ? require("../../google-service.json")
        : require("../../google-service.staging.json");
  } catch {
    firebaseConfig = require("../../google-service.staging.json");
  }
} catch {
  console.error(`Can't load the firebase config file. Please check it again`);
  firebaseConfig = {
    apiKey: "AIzaSyDWx1iHcOxCK5E4PfC8Bl9IJJaGia9GaCQ",
    authDomain: "vitalliance-chat-dev.firebaseapp.com",
    databaseURL:
      "https://vitalliance-chat-dev-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "vitalliance-chat-dev",
    storageBucket: "vitalliance-chat-dev.appspot.com",
    messagingSenderId: "1067782889465",
    appId: "1:1067782889465:web:572ff5c7cbe07ee1dd6728",
    measurementId: "G-FJ0B68WXNQ",
  };
}
firebase.initializeApp(firebaseConfig);
// Initialize analytics only if getAnalytics is available (e.g., in browser)
export default firebase;

/**
 * Write or replace data to a defined path
 * @param refPath Reference path firebase
 * @param childPath Child path firebase
 * @param payload Value to save in firebase realtime database
 */
export const create = async (refPath, childPath, payload) => {
  const ref = firebase.database().ref(refPath);
  const childRef = ref.child(childPath);
  await childRef.set(payload);
};

export const getFirebaseDB = (name) => {
  return firebase.database().ref(name);
};
const analytics = firebase.analytics();
export { analytics };

